import { apiRoutes } from '../../api-routes';
import { httpClient } from '../../util/http-client';
import type { User } from './types';

export const getUserProfileFn = async () => {
  const response = await httpClient.get<User>(apiRoutes.user.profile);
  return response.data;
};
